import { useContext } from "react";
import { context } from "../../context/context";

export default function useNewId () {
    const { cart } = useContext(context);

    const newId = cart.length > 0 ? 
    cart[cart.length - 1].id + 1
    : 1;

    return newId;
}